
import { Component, Prop, Vue } from 'bits/vue'

@Component({})
export default class DashboardSettingsBillingModalTitle extends Vue {
  @Prop() title!: string
  @Prop() subtitle!: string
}
